import type {FC, ReactNode} from 'react';
import {memo} from 'react';

import TopMenuLayoutPublic from '../TopMenuLayoutPublic/TopMenuLayoutPublic';

interface Props {
  allHeight?: boolean;
  children: ReactNode;
  className?: string;
  isThreeColumn?: boolean;
  loginButtonText?: string;
  offsetMenuContainerClass?: string;
}

const MainContainerPublicPage: FC<Props> = ({
  allHeight = false,
  children,
  className = '',
  isThreeColumn = false,
  loginButtonText,
  offsetMenuContainerClass = '',
}) => {
  return (
    <main className={`MainContainerPublicPage ${className}`}>
      <div className={`container ${isThreeColumn ? 'threeColumns' : ''}`}>
        <div
          className={`offsetMenuContainer ${
            allHeight ? 'allHeight' : ''
          } ${offsetMenuContainerClass}`}
        >
          <TopMenuLayoutPublic loginButtonText={loginButtonText} />
          {!isThreeColumn ? children : null}
        </div>
      </div>
      {isThreeColumn ? children : null}
    </main>
  );
};

export default memo(MainContainerPublicPage);
